import MarkAllReadButton from './MarkAllReadButton';

export default MarkAllReadButton;
